export type RequestPhase = 'session' | 'fetch' | 'body' | 'validation';
export type RequestFailure = 'session' | 'network' | 'timeout' | 'http' | 'invalid' | 'cancelled' | 'unknown';
/** Only fixed classifications/numbers: never retain the raw error, URL, body or token. */
export class GemaRequestError extends Error {
  constructor(public kind: RequestFailure, public phase: RequestPhase, public status?: number, public retryAfterMs?: number) {
    super('Gema request failed');
    this.name = 'GemaRequestError';
  }
}
export function classifyRequestError(error: unknown, phase: RequestPhase): GemaRequestError {
  if (error instanceof GemaRequestError) return error;
  if ((error instanceof Error || error instanceof DOMException) && error.name === 'TimeoutError') return new GemaRequestError('timeout', phase);
  if ((error instanceof Error || error instanceof DOMException) && error.name === 'AbortError') return new GemaRequestError('cancelled', phase);
  if (phase === 'session') return new GemaRequestError('session', phase);
  if (error instanceof SyntaxError) return new GemaRequestError('invalid', phase);
  if (error instanceof TypeError) return new GemaRequestError('network', phase);
  return new GemaRequestError('unknown', phase);
}
export function automaticRetryDelay(error: GemaRequestError): number | null {
  if (error.kind === 'network' || error.kind === 'timeout') return 1000;
  // 429 is deliberately not retried automatically. Never shorten Retry-After.
  if (error.kind === 'http' && [500, 502, 503, 504].includes(error.status ?? 0)) {
    if (error.retryAfterMs !== undefined && error.retryAfterMs > 5000) return null;
    return Math.max(1000, error.retryAfterMs ?? 0);
  }
  return null;
}
